/**
 * LockVue API
 * APIs to interact with LockVue Devices and Telemetry
 *
 * OpenAPI spec version: v2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EncryptedUnlockPacket } from '../model/encryptedUnlockPacket';
import { KeyRequestModel } from '../model/keyRequestModel';
import { Lock } from '../model/lock';
import { LocksPoolBillableFlagModel } from '../model/locksPoolBillableFlagModel';
import { ManualUnlockCodeModel } from '../model/manualUnlockCodeModel';
import { NewLockModel } from '../model/newLockModel';
import { RebrandRequestModel } from '../model/rebrandRequestModel';
import { RekeyRequestModel } from '../model/rekeyRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class LocksPoolAdminService {

    protected basePath = 'http://localhost:5192/api/v2';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Adds a new lock into the system
     * 
     * @param body Model containing valid lock details
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminAdd(body?: NewLockModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public locksPoolAdminAdd(body?: NewLockModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public locksPoolAdminAdd(body?: NewLockModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public locksPoolAdminAdd(body?: NewLockModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/admin/LocksPool/Add`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns all locks contained in the lock pools including available and already activated locks.
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminAll(observe?: 'body', reportProgress?: boolean): Observable<Array<Lock>>;
    public locksPoolAdminAll(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Lock>>>;
    public locksPoolAdminAll(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Lock>>>;
    public locksPoolAdminAll(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Lock>>('get',`${this.basePath}/admin/LocksPool/All`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns all available (non active) locks from the lock pool.
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminAvailable(observe?: 'body', reportProgress?: boolean): Observable<Array<Lock>>;
    public locksPoolAdminAvailable(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Lock>>>;
    public locksPoolAdminAvailable(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Lock>>>;
    public locksPoolAdminAvailable(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Lock>>('get',`${this.basePath}/admin/LocksPool/Available`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Makes a non-activated lock from the lock-pool billable or non-billable
     * 
     * @param body Model containing a valid lock serial number and the billable flag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminBillable(body?: LocksPoolBillableFlagModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public locksPoolAdminBillable(body?: LocksPoolBillableFlagModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public locksPoolAdminBillable(body?: LocksPoolBillableFlagModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public locksPoolAdminBillable(body?: LocksPoolBillableFlagModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/admin/LocksPool/Billable`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets encryption keys of a lock from the lock-pool identified by its serial number.
     * 
     * @param body Model containing:
- Valid app-id of a verified lockvue admin app
- MAC / Hardware address of the lock.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminGetKeys(body?: KeyRequestModel, observe?: 'body', reportProgress?: boolean): Observable<EncryptedUnlockPacket>;
    public locksPoolAdminGetKeys(body?: KeyRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EncryptedUnlockPacket>>;
    public locksPoolAdminGetKeys(body?: KeyRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EncryptedUnlockPacket>>;
    public locksPoolAdminGetKeys(body?: KeyRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<EncryptedUnlockPacket>('post',`${this.basePath}/admin/LocksPool/GetKeys`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the manual unlock code such as the quick-click code of a lock in the locks pool.
     * 
     * @param body Model containing the MAC address of the lock. Note: other parameters are unused.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminGetManualUnlockCode(body?: KeyRequestModel, observe?: 'body', reportProgress?: boolean): Observable<Array<ManualUnlockCodeModel>>;
    public locksPoolAdminGetManualUnlockCode(body?: KeyRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ManualUnlockCodeModel>>>;
    public locksPoolAdminGetManualUnlockCode(body?: KeyRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ManualUnlockCodeModel>>>;
    public locksPoolAdminGetManualUnlockCode(body?: KeyRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ManualUnlockCodeModel>>('post',`${this.basePath}/admin/LocksPool/GetManualUnlockCode`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rebrands available (the ones not activated) locks identified by either the  given SerialNumber or the MAC address.    Please note that either the SerialNumber (preferred) or the MAC address must  be provided. If both are provided then the SerialNumber value is used and the  MAC address value is ignored.
     * 
     * @param body Model containing valid lock rebranding details
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminRebrand(body?: RebrandRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public locksPoolAdminRebrand(body?: RebrandRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public locksPoolAdminRebrand(body?: RebrandRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public locksPoolAdminRebrand(body?: RebrandRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/admin/LocksPool/Rebrand`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rekeys available (the ones not activated) locks identified by either the  given SerialNumber or the MAC address.    Please note that either the SerialNumber (preferred) or the MAC address must  be provided. If both are provided then the SerialNumber value is used and the  MAC address value is ignored.
     * 
     * @param body Model containing valid lock rekey details
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public locksPoolAdminRekey(body?: RekeyRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public locksPoolAdminRekey(body?: RekeyRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public locksPoolAdminRekey(body?: RekeyRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public locksPoolAdminRekey(body?: RekeyRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (ApiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["x-api-key"]) {
            headers = headers.set('x-api-key', this.configuration.apiKeys["x-api-key"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/admin/LocksPool/Rekey`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
